import { useState } from "react";
import Reveal from "@/components/Reveal";

const VIDEO_ID = "oLQxBsb5xdA";

export default function VideoSection() {
  const [playing, setPlaying] = useState(false);

  return (
    <section
      data-testid="video-section"
      className="bg-white px-6 py-20 md:px-12 md:py-28"
    >
      <Reveal>
        <div className="relative mx-auto aspect-video w-full max-w-4xl overflow-hidden rounded-3xl border border-[#E3EBF3] bg-[#F3F7FB] shadow-[0_18px_44px_rgba(11,36,64,0.10)]">
          {playing ? (
            <iframe
              data-testid="youtube-iframe"
              src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
              title="Video LLDIKTI Wilayah VII"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 h-full w-full"
            />
          ) : (
            <button
              data-testid="video-thumbnail"
              onClick={() => setPlaying(true)}
              aria-label="Putar video"
              className="group absolute inset-0 block h-full w-full"
            >
              <img
                src={`https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                alt="Thumbnail video LLDIKTI Wilayah VII"
                data-testid="video-thumbnail-image"
                onError={(e) => {
                  e.currentTarget.src = `https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`;
                }}
                className="h-full w-full object-cover"
              />
              <span
                aria-hidden="true"
                className="absolute inset-0 bg-[#0B2440]/25 transition-colors duration-300 group-hover:bg-[#0B2440]/10"
              />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 shadow-[0_10px_30px_rgba(11,36,64,0.25)] transition-transform duration-300 group-hover:scale-110 md:h-20 md:w-20">
                  <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    className="ml-1 h-7 w-7 fill-[#1479BF] md:h-8 md:w-8"
                  >
                    <path d="M8 5.5v13l11-6.5-11-6.5z" />
                  </svg>
                </span>
              </span>
            </button>
          )}
        </div>
      </Reveal>
    </section>
  );
}
